"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.LocationClient = void 0;
var MockClient_1 = require("./MockClient");
var Client_1 = require("./Client");
var useMock_1 = __importDefault(require("../util/useMock"));
exports.LocationClient = {
    getLocation: function (id) { return useMock_1.default() ? MockClient_1.MockLocationsClient.getLocation(id) : Client_1.LocationClient.getLocation(id); },
    getLocations: function () { return useMock_1.default() ? MockClient_1.MockLocationsClient.getLocations() : Client_1.LocationClient.getLocations(); },
    getMenuItem: function (locationId, menuId, itemId) {
        return useMock_1.default() ? MockClient_1.MockLocationsClient.getMenuItem(locationId, menuId, itemId) : Client_1.LocationClient.getMenuItem(locationId, menuId, itemId);
    },
    createMenuItem: function (locationId, menuId, item, authToken) {
        return useMock_1.default() ? MockClient_1.MockLocationsClient.createMenuItem(locationId, menuId, item) : Client_1.LocationClient.createMenuItem(locationId, menuId, item, authToken);
    },
    updateMenuItem: function (locationId, menuId, itemId, item, authToken) {
        return useMock_1.default() ? MockClient_1.MockLocationsClient.updateMenuItem(locationId, menuId, itemId, item) : Client_1.LocationClient.updateMenuItem(locationId, menuId, itemId, item, authToken);
    },
    deleteMenuItem: function (locationId, menuId, itemId, authToken) {
        return useMock_1.default() ? MockClient_1.MockLocationsClient.deleteMenuItem(locationId, menuId, itemId) : Client_1.LocationClient.deleteMenuItem(locationId, menuId, itemId, authToken);
    },
    getMenu: function (locationId, menuId, authToken) {
        return useMock_1.default() ? MockClient_1.MockLocationsClient.getMenu(locationId, menuId) : Client_1.LocationClient.getMenu(locationId, menuId, authToken);
    },
    getMenus: function (locationId, authToken) {
        return useMock_1.default() ? MockClient_1.MockLocationsClient.getMenus(locationId) : Client_1.LocationClient.getMenus(locationId, authToken);
    },
    getLiveAndActiveMenus: function (locationId) {
        return useMock_1.default() ? MockClient_1.MockLocationsClient.getMenus(locationId) : Client_1.LocationClient.getLiveAndActiveMenus(locationId);
    },
    createMenu: function (locationId, menu, authToken) {
        return useMock_1.default() ? MockClient_1.MockLocationsClient.createMenu(locationId, menu) : Client_1.LocationClient.createMenu(locationId, menu, authToken);
    },
    updateMenu: function (locationId, menuId, menu, authToken) {
        return useMock_1.default() ? MockClient_1.MockLocationsClient.updateMenu(locationId, menuId, menu) : Client_1.LocationClient.updateMenu(locationId, menuId, menu, authToken);
    },
    deleteMenu: function (locationId, menuId, authToken) {
        return useMock_1.default() ? MockClient_1.MockLocationsClient.deleteMenu(locationId, menuId) : Client_1.LocationClient.deleteMenu(locationId, menuId, authToken);
    },
    getProduct: function (locationId, productId) {
        return useMock_1.default() ? MockClient_1.MockLocationsClient.getProduct(locationId, productId) : Client_1.LocationClient.getProduct(locationId, productId);
    },
    getProducts: function (locationId) {
        return useMock_1.default() ? MockClient_1.MockLocationsClient.getProducts(locationId) : Client_1.LocationClient.getProducts(locationId);
    },
    createProduct: function (locationId, product, authToken) {
        return useMock_1.default() ? MockClient_1.MockLocationsClient.createProduct(locationId, product) : Client_1.LocationClient.createProduct(locationId, product, authToken);
    },
    updateProduct: function (locationId, productId, product, authToken) {
        return useMock_1.default() ? MockClient_1.MockLocationsClient.updateProduct(locationId, productId, product) : Client_1.LocationClient.updateProduct(locationId, productId, product, authToken);
    },
    deleteProduct: function (locationId, productId, authToken) {
        return useMock_1.default() ? MockClient_1.MockLocationsClient.deleteProduct(locationId, productId) : Client_1.LocationClient.deleteProduct(locationId, productId, authToken);
    },
    getArea: function (locationId, areaId, authToken) {
        return useMock_1.default() ? MockClient_1.MockLocationsClient.getArea(locationId, areaId) : Client_1.LocationClient.getArea(locationId, areaId, authToken);
    },
    getAreas: function (locationId, authToken) {
        return useMock_1.default() ? MockClient_1.MockLocationsClient.getAreas(locationId) : Client_1.LocationClient.getAreas(locationId, authToken);
    },
    createArea: function (locationId, area, authToken) {
        return useMock_1.default() ? MockClient_1.MockLocationsClient.createArea(locationId, area) : Client_1.LocationClient.createArea(locationId, area, authToken);
    },
    deleteArea: function (locationId, areaId, authToken) {
        return useMock_1.default() ? MockClient_1.MockLocationsClient.deleteArea(locationId, areaId) : Client_1.LocationClient.deleteArea(locationId, areaId, authToken);
    },
    getInvoiceUrl: function (locationId, invoiceId, authToken) {
        return useMock_1.default() ? MockClient_1.MockLocationsClient.getInvoiceUrl(locationId, invoiceId, authToken) : Client_1.LocationClient.getInvoiceUrl(locationId, invoiceId, authToken);
    },
    createAssetUrl: function (locationId, asset, authToken) {
        return useMock_1.default() ? MockClient_1.MockLocationsClient.createAssetUrl(locationId, asset, authToken) : Client_1.LocationClient.createAssetUrl(locationId, asset, authToken);
    },
    setBaseUrl: function (url) { return Client_1.LocationClient.setBaseUrl(url); },
};
